import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject } from "aurelia-framework";
import { UserManager } from "oidc-client-ts";

import { getLogger } from "./logging";

export const UserSignedOut = "oidc:user-signed-out";

@autoinject
export class OidcEventHandler {

    private readonly _logger = getLogger("oidc-event-handler");
    private readonly _ea: EventAggregator;

    public constructor(ea: EventAggregator) {
        this._ea = ea;
    }

    public attach(userManager: UserManager) {
        userManager.events.addUserSignedOut(() => this.publishAndLog(UserSignedOut));
        this._ea.subscribe(UserSignedOut, async (location: string) => {
            this._logger.debug("Handling sign-out request.", location);
            await userManager.removeUser();
            window.location.reload();
        });
    }

    private publishAndLog(channel: string) {
        this._logger.debug(`Event occured on channel ${channel}.`);
        this._ea.publish(channel);
    }
}
